export default __webpack_public_path__ + "static/media/golden-coin.61ca045b.webp";